import { ref, getValues, watchValues } from '@dbk-legacy/muster/utils';
import { assetSortable, variable } from '@dbk-legacy/muster/helpers';
import map from 'lodash/fp/map';
import byKey from '../muster/utils/by-key';
import { PAGE } from '../constants';
export default (app, {
  positionsSortedRoute = true,
  staticRoute = true,
} = {}) => {
  app
    .require('assetsCommonCh.data', { '*': true })
    .require('assetsCommonCh.portfolioData', { '*': true })
    .require('assetsCommonCh.sortIsAscending', { get: true })
    .require('assetsCommonCh.sortByKey', { get: true })
    .require('assetsCommonCh.static', { '*': true })
    .require('assetsCommonCh.state', { '*': true })
    .require('assetsCommonCh.search', { '*': true })
    .require('assets.config.pageSize',{ get: true  })
    .path('title', ({ res }) => {
      return res.redirect('assetsCommonCh.data.positions[0].security.title')
    }
    )
    .path('marketValue', ({ res }) => {
      return res.redirect('assetsCommonCh.portfolioData.marketValue.value')
    }
    )
    .path('dayChange.percentage', ({ res }) => {
      return res.redirect('assetsCommonCh.portfolioData.dayChange.percent')
    }
    )
    .path('dayChange.value', ({ res }) => {
      return res.redirect('assetsCommonCh.portfolioData.dayChange.value')
    }
    )
    .path('positions.pageOffset', variable(0))
    .path('positions.pageSize', ({ res }, { get }) =>
      getValues(get(['assetsCommonCh.data.positions.length', 'positions.pageOffset' , 'assets.config.pageSize']))
        .then(([positionsLength, pageOffset ,assetPageSize]) => {
          const pageOffsetEnd = pageOffset +  assetPageSize ;
          if (pageOffset === 0 && positionsLength < pageOffsetEnd) {
            /* records is less than page size */
            return {
              path: 'positions.pageSize',
              value: positionsLength,
            };
          } else {
            /* records is more than page size */
            return {
              path: 'positions.pageSize',
              value: pageOffsetEnd < positionsLength ?  assetPageSize  : positionsLength - pageOffset,
            };
          }
        })
    )
    .path('positions.length', ({ res }) => {
      return res.redirect('assetsCommonCh.data.positions.length')
    }
    )
    // .match('positions[{integers:i}].priceHistory[{integers:j}][{keys:k}]', map(({ req, res }) =>
    //   res.redirect(`assetsCommon.data.positions[${req.params.i}]`
    //     + `.priceHistory[${req.params.j}].${req.params.k}`)
    // ))
    .match('positions[{integers:i}][{keys:k1}][{keys:k2}]', map(({ req, res }) => {
      return res.redirect(`assetsCommonCh.data.positions[${req.params.i}].${req.params.k1}.${req.params.k2}`)
    }
    ))
    .match('positions[{integers:i}][{keys:k}]', map(({ req, res }) => {
      return res.redirect(`assetsCommonCh.data.positions[${req.params.i}].${req.params.k}`)
    }
    ))
    .match('positionsByPosId[{keys:k}]', (requests, { get }) =>
      watchValues(get('assetsCommonCh.search.filter.positionId'))
        .map(([positionId]) =>
          requests.map(({ req, res }) => {
            if (positionId == null) {
              return {
                path: req.path,
                value: null,
              };
            } else {
              return res.redirect(`assetsCommonCh.data.positions.pos${positionId}.${req.params.k}`);
            }
          })
        )
    )
    .match('positionsByPosId[{keys:k1}][{keys:k2}]', (requests, { get }) =>
      watchValues(get('assetsCommonCh.search.filter.positionId'))
        .map(([positionId]) =>
          requests.map(({ req, res }) => {
            if (positionId == null) {
              return {
                path: req.path,
                value: null,
              };
            } else {
              return res.redirect(`assetsCommonCh.data.positions.pos${positionId}.${req.params.k1}.${req.params.k2}`);
            }
          })
        )
    )
    .match('positionsById[{keys:id}].*', byKey(
      'assetsCommonCh.data.positions',
      'id'
    ))
    .match('state.*', {
      get: requests => requests.map(
        ({ req, res }) => res.redirect(`assetsCommonCh.state.${req.params['*']}`)
      ),
      set: requests => requests.map(
        ({ req, res }) => res.redirect(`assetsCommonCh.state.${req.params['*']}`)
      ),
    });

  if (positionsSortedRoute) {
    app
      .match('positionsSorted[{integers:index}].*', assetSortable({
        fromList: 'positions',
        toList: 'positionsSorted',
        listOffset: ref('positions.pageOffset'),
        listLength: ref('positions.pageSize'),
        isAscending: ref('assetsCommonCh.sortIsAscending'),
        sortByKey: ref('assetsCommonCh.sortByKey'),
      }))
      .path('positionsSorted.length', ({ res }) =>
        res.redirect('positions.length'));
  }

  if (staticRoute) {
    app.match('static.*', requests => requests.map(
      ({ req, res }) => res.redirect(`assetsCommonCh.static.${req.params['*']}`))
    );
  }

  return app;
};
